import React from "react";
import "./About.css"; // Optional: for custom styles
import aboutUsbg from "../../assets/aboutUs.png";

const About = () => {
  return (
    <div>
      <img
        src={aboutUsbg}
        alt="About Us"
        className="img-fluid d-flex justify-content-center mx-auto d-block"
        style={{ width: "60%", height: "300px" }}
      />

      <div className="container my-5 py-5 px-4 bg-light rounded shadow">
        {/* <h2 className="text-center mb-4 display-5 fw-bold text-primary">
          About Us
        </h2> */}
        <p className="lead text-center text-secondary mb-5">
          Welcome to <strong>Zenovus Technologies</strong>, where innovation
          meets excellence. We are a team of creative thinkers, tech
          enthusiasts, and digital strategists dedicated to transforming ideas
          into impactful digital experiences.
        </p>

        <div className="row">
          <div className="col-md-6">
            <h4 className="text-dark mb-3">Our Services</h4>
            <ul className="list-group list-group-flush">
              <li className="list-group-item bg-light">
                <strong>🔧 Software Services:</strong> Scalable and secure
                software tailored to your business.
              </li>
              <li className="list-group-item bg-light">
                <strong>🎨 Product Design & Development:</strong> From concept
                to launch, we bring your ideas to life.
              </li>
              <li className="list-group-item bg-light">
                <strong>🌐 Online Services:</strong> Cloud integration, SaaS
                platforms, and digital transformation.
              </li>
              <li className="list-group-item bg-light">
                <strong>💻 Website Development:</strong> Responsive,
                SEO-friendly websites that drive results.
              </li>
              <li className="list-group-item bg-light">
                <strong>📣 Social Media Campaigning:</strong> Engaging campaigns
                that build brand loyalty.
              </li>
              <li className="list-group-item bg-light">
                <strong>📊 Digital Marketing:</strong> SEO, PPC, content
                marketing, and analytics.
              </li>
            </ul>
          </div>

          <div className="col-md-6">
            <h4 className="text-dark mb-3">Why Choose Us?</h4>
            <ul className="list-group list-group-flush">
              <li className="list-group-item bg-light">
                ✅ Customer-Centric Approach
              </li>
              <li className="list-group-item bg-light">
                ✅ Innovative & Scalable Solutions
              </li>
              <li className="list-group-item bg-light">
                ✅ Transparent Communication
              </li>
              <li className="list-group-item bg-light">✅ Timely Delivery</li>
              <li className="list-group-item bg-light">✅ Dedicated Support</li>
            </ul>
          </div>
        </div>

        <p className="mt-5 text-center text-muted">
          We don’t just deliver projects—we build partnerships. Let’s grow
          together.
        </p>
      </div>
    </div>
  );
};

export default About;
